import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
  providedIn: 'root'
})
export class BadgeSelectorService {

  data: any = {
    badges: [],
    badgesLoaded: true
  }

  constructor(
    private cvApiService: CVApiService
  ) { }

  async loadBadges() {
    try {
      let url = "/api/v1/gamification/badges";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.badges = response.data;
        this.data.badgesLoaded = true;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading badges: " + error.message);
    }
  }

  async saveCustomBadge(data: any, badgeType: string) {
    try {
      let url = "";
      if (badgeType == "award") {
        url = "/api/v1/gamification/custombadges";
      } else {
        url = "/api/v1/gamification/xplevels/custominsignias";
      }
      let response = await this.cvApiService.put(url, data);

      if (response.status_code >= 200 && response.status_code < 300) {
        return response;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error saving new badge: " + error.message);
    }
  }
}